export default [
  { value: 'BED', label: 'Bedfordshire' },
  { value: 'BERK', label: 'Berkshire' },
  { value: 'BUCK', label: 'Buckinghamshire' },
  { value: 'CAM', label: 'Cambridgeshire' },
  { value: 'CHES', label: 'Cheshire' },
  { value: 'CORN', label: 'Cornwall' },
  { value: 'CUMB', label: 'Cumbria' },
  { value: 'DERB', label: 'Derbyshire' },
  { value: 'DEV', label: 'Devon' },
  { value: 'DOR', label: 'Dorset' },
  { value: 'DUR', label: 'County Durham' },
  { value: 'ERYORK', label: 'East Riding of Yorkshire' },
  { value: 'ESX', label: 'East Sussex' },
  { value: 'ESS', label: 'Essex' },
  { value: 'GLS', label: 'Gloucestershire' },
  { value: 'GMAN', label: 'Greater Manchester' },
  { value: 'HANTS', label: 'Hampshire' },
  { value: 'HERTS', label: 'Hertfordshire' },
  { value: 'HANTS', label: 'Herefordshire' },
  { value: 'IOW', label: 'Isle of Wight' },
  { value: 'KENT', label: 'Kent' },
  { value: 'LANCS', label: 'Lancashire' },
  { value: 'LEICS', label: 'Leicestershire' },
  { value: 'LINCS', label: 'Lincolnshire' },
  { value: 'LOND', label: 'Greater London' },
  { value: 'MER', label: 'Merseyside' },
  { value: 'NORF', label: 'Norfolk' },
  { value: 'NHANTS', label: 'Northamptonshire' },
  { value: 'NTHUMB', label: 'Northumberland' },
  { value: 'NOTTS', label: 'Nottinghamshire' },
  { value: 'OXON', label: 'Oxfordshire' },
  { value: 'RUT', label: 'Rutland' },
  { value: 'SHROP', label: 'Shropshire' },
  { value: 'SOM', label: 'Somerset' },
  { value: 'STS', label: 'Staffordshire' },
  { value: 'SUFF', label: 'Suffolk' },
  { value: 'SURREY', label: 'Surrey' },
  { value: 'TYNE', label: 'Tyne and Wear' },
  { value: 'WARKS', label: 'Warwickshire' },
  { value: 'W MIDS', label: 'West Midlands' },
  { value: 'W SUSX', label: 'West Sussex' },
  { value: 'WILTS', label: 'Wiltshire' },
  { value: 'WORCS', label: 'Worcestershire' },
  { value: 'YORK', label: 'North Yorkshire' },
  { value: 'SYORK', label: 'South Yorkshire' },
  { value: 'WYORK', label: 'West Yorkshire' },
  { value: 'WALES', label: 'Wales' },
  { value: 'SCOT', label: 'Scotland' },
  { value: 'NIRE', label: 'Northern Ireland' }
]
